import React, { Fragment, useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import logo from "../../assets/images/logo.png";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarItems } from "../../utils/constants";

const { Sider } = Layout;

const AppSidebar = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const [collapsed, setCollapsed] = useState(true);
  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(pathname);
  }, [pathname]);

  return (
    <Fragment>
      <Sider
        trigger={null}
        collapsible
        breakpoint="lg"
        collapsed={collapsed}
        onBreakpoint={(broken) => {
          // console.log(broken);
        }}
        onCollapse={() => setCollapsed(!collapsed)}
        style={{ position: "relative" }}
      >
        <div className="demo-logo-vertical" />
        <div
          className="collapse_button"
          title="Menu"
          style={{ justifyContent: collapsed ? "center" : "end" }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => {
                setCollapsed(!collapsed);
              },
            }
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[path]}
          items={SidebarItems}
          onClick={({ key }) => {
            navigate(key);
          }}
        />

        <img
          style={{
            width: "-webkit-fill-available",
            padding: collapsed ? "0rem 1rem" : "0rem 3.5rem",
            position: "absolute",
            bottom: "20px",
            transition: "width 0.01s ease, padding 0.3s ease",
          }}
          src={logo}
          alt="logo"
        />
      </Sider>
    </Fragment>
  );
};

export default AppSidebar;
